"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rowStyle = exports.getFilteredSharingActions = exports.cellRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _ItemTableStyled = require("./ItemTable-styled");
var _helper = require("../../utils/helper");
var _helper2 = require("../resources/helper");
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var cellRenderer = function cellRenderer(_ref, portal, customCellRenderer) {
  var _rowData$typeKeywords;
  var cellData = _ref.cellData,
    columnData = _ref.columnData,
    columnIndex = _ref.columnIndex,
    dataKey = _ref.dataKey,
    isScrolling = _ref.isScrolling,
    rowData = _ref.rowData,
    rowIndex = _ref.rowIndex;
  if (customCellRenderer) {
    return customCellRenderer({
      cellData: cellData,
      columnData: columnData,
      columnIndex: columnIndex,
      dataKey: dataKey,
      isScrolling: isScrolling,
      rowData: rowData,
      rowIndex: rowIndex,
      getItemTypeIcon: _helper2.getItemTypeIcon
    });
  }
  switch (dataKey) {
    case "title":
      return /*#__PURE__*/_react.default.createElement(_ItemTableStyled.StyledImgSpan, null, (0, _helper2.getItemTypeIcon)(rowData, {
        margin: "0 0.5rem 0 0",
        minWidth: "16px"
      }), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteLink, {
        title: cellData,
        href: (0, _helper.getItemOrgPageUrl)(portal, rowData.id),
        target: "_blank"
      }, cellData));
    case "type":
      if ((_rowData$typeKeywords = rowData.typeKeywords) === null || _rowData$typeKeywords === void 0 ? void 0 : _rowData$typeKeywords.includes("Table")) {
        return "Table";
      }
      return cellData;
    case "created":
    case "modified":
      return (0, _moment.default)(cellData).format("MMM D, YYYY");
    default:
      return cellData;
  }
};
exports.cellRenderer = cellRenderer;
var rowStyle = function rowStyle(_ref2) {
  var index = _ref2.index;
  var styles = {
    borderBottom: "1px solid #eee",
    width: "100%",
    backgroundColor: "#fff",
    height: 49
  };
  if (index === -1) {
    // For header row, return custom styles
    return {
      borderBottom: "none",
      backgroundColor: "#fff"
    };
  }
  return styles;
};
exports.rowStyle = rowStyle;
var getFilteredSharingActions = function getFilteredSharingActions(_ref3) {
  var rowIndex = _ref3.rowIndex,
    queryResults = _ref3.queryResults,
    sharingActions = _ref3.sharingActions;
  var filteredSharingActions = [];
  var matchingSharingAction = null;
  var groupAction = null;
  if (queryResults && (queryResults === null || queryResults === void 0 ? void 0 : queryResults.results[rowIndex])) {
    matchingSharingAction = sharingActions.find(function (action) {
      return action.id === (queryResults === null || queryResults === void 0 ? void 0 : queryResults.results[rowIndex].access);
    });
  }
  if (matchingSharingAction) {
    filteredSharingActions = [].concat(_toConsumableArray(filteredSharingActions), [matchingSharingAction]);
    if (queryResults === null || queryResults === void 0 ? void 0 : queryResults.results[rowIndex].accessInformation) {
      groupAction = sharingActions.find(function (action) {
        return action.id === "group";
      });
    }
    if (groupAction) {
      filteredSharingActions = [].concat(_toConsumableArray(filteredSharingActions), [groupAction]);
    }
  }
  return filteredSharingActions;
};
exports.getFilteredSharingActions = getFilteredSharingActions;